import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../redux/store';

interface IAuthState {
    token: string;
    tenantId: string;
    userId: string;
}

const initialState: IAuthState = {
    token: '',
    tenantId: '',
    userId: '',
}

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;
        },
        setTenantId: (state, action: PayloadAction<string>) => {
            state.tenantId = action.payload;
        },
        setUserId: (state, action: PayloadAction<string>) => {
            state.userId = action.payload;
        },
    },
});

const {
    setToken,
    setTenantId,
    setUserId,
} = authSlice.actions;

export const setAuthToken =
    (token: string): AppThunk =>
        async (dispatch) => {
            dispatch(setToken(token));
        };

export const saveTenantId =
    (tenantId: string): AppThunk =>
        async (dispatch) => {
            dispatch(setTenantId(tenantId));
        };

export const saveUserId =
    (userId: string): AppThunk =>
        async (dispatch) => {
            dispatch(setUserId(userId));
        };

export const selectAuth = (state: RootState) =>
    state.authState;

export default authSlice.reducer;